import _createForOfIteratorHelper from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/workBag/projectDemo/vuedemo10/xmmanagement/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-394a48b3"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "headerInfo"
};
import { ref } from "@vue/reactivity";
import { getCurrentInstance, nextTick, onMounted, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import { getCompanyList } from "@/api/xmManagement/production/product";
import { useRoute } from "vue-router";
import { isNull_Any } from "@/utils";
import router from "@/router";
export default {
  __name: 'lang',
  setup: function setup(__props) {
    var _getCurrentInstance = getCurrentInstance(),
        proxy = _getCurrentInstance.proxy;

    var socketServes = ref({
      socketServe: proxy.$SocketService.Instance
    });
    var store = useStore();
    var regionValue = ref({
      region: "",
      company: ""
    });
    var route = useRoute(); // 公司列表定义

    var selectsList = ref([]); // 区域

    var region = ref([]); // 获取公司列表

    var getCompanyListData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var company_list, companyId, _iterator, _step, i, _iterator2, _step2, j, _iterator3, _step3, _i;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                company_list = JSON.parse(localStorage.getItem("companyList"));
                console.log(company_list);
                companyId = localStorage.getItem("company");

                if (!isNull_Any(companyId)) {
                  regionValue.value.company = companyId;
                } else {
                  localStorage.setItem("company", company_list[0]["companyId"]);
                  regionValue.value.company = company_list[0]["companyId"];
                  console.log(regionValue.value, company_list);
                  store.commit("app/setCompany", company_list[0]["companyId"]);
                }

                if (!isNull_Any(localStorage.getItem("region"))) {
                  _iterator = _createForOfIteratorHelper(company_list);

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      i = _step.value;
                      _iterator2 = _createForOfIteratorHelper(i.region_list);

                      try {
                        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                          j = _step2.value;

                          if (localStorage.getItem("region") === j.region) {
                            regionValue.value.region = localStorage.getItem("region");
                          }
                        }
                      } catch (err) {
                        _iterator2.e(err);
                      } finally {
                        _iterator2.f();
                      }
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                } else {
                  regionValue.value.region = company_list[0]["region_list"][0].region;
                  store.commit("app/setRegion", company_list[0]["region_list"][0].region);
                }

                _iterator3 = _createForOfIteratorHelper(company_list);

                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    _i = _step3.value;

                    if (_i.companyId === regionValue.value.company) {
                      region.value = _i.region_list;
                    }
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }

                selectsList.value = company_list;
                socketServes.value.socketServe.connect(store.getters.token, regionValue.value.region);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function getCompanyListData() {
        return _ref.apply(this, arguments);
      };
    }();

    var changeRegion = function changeRegion(item) {
      store.commit("app/setLoading");

      if (item !== undefined && item !== null) {
        store.commit("app/setRegion", item);
        localStorage.setItem("region", item);
      } // proxy.$tab.refreshPage(route)


      proxy.$tab.closeAllPage();
      store.dispatch("app/getMenuList");

      if (store.getters.token) {
        socketServes.value.socketServe.connect(store.getters.token, regionValue.value.region);
      }

      router.replace({
        path: "/home"
      });
      setTimeout(function () {
        window.location.reload();
      }, 300); // store.commit('app/setCloseLoading')
    };

    var changeCompany = function changeCompany(item) {
      store.commit("app/setLoading");
      changeRegion(regionValue.value.region);

      var _iterator4 = _createForOfIteratorHelper(selectsList.value),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var i = _step4.value;

          if (i.companyId === item) {
            region.value = i.region_list;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      console.log(selectsList.value, "selectsList.value");
      localStorage.setItem("company_id", item);
      localStorage.setItem("company", item);
      store.commit("app/setCompany", item); // proxy.$tab.refreshPage(route)

      proxy.$tab.closeAllPage();
      store.dispatch("app/getMenuList");
      router.replace({
        path: "/home"
      });
      setTimeout(function () {
        window.location.reload();
      }, 300); // store.commit('app/setCloseLoading')
    };

    onMounted(function () {
      getCompanyListData();
    });
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_select, {
        class: "select-item",
        style: {
          "width": "100px"
        },
        onChange: changeRegion,
        modelValue: _unref(regionValue).region,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _unref(regionValue).region = $event;
        }),
        placeholder: "请输入地区"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(region), function (item, index) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.region
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_select, {
        class: "select-item",
        style: {
          "width": "110px",
          "margin-right": "20px"
        },
        onChange: changeCompany,
        modelValue: _unref(regionValue).company,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _unref(regionValue).company = $event;
        }),
        placeholder: "请选择公司"
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectsList), function (item, index) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.company,
              value: item.companyId
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};